import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../styles/public-site.css";

// The public site is a multi-page marketing/help/auth experience. React Router
// keeps the previous scroll position between pages, so footer links would land
// the reader at the bottom of the next page. This wrapper restores the
// expected behaviour: new path → top of page, hash → the matching section.
const scrollToHash = (hash) => {
  if (!hash || typeof document === "undefined") return false;
  let id = hash.slice(1);
  try {
    id = decodeURIComponent(id);
  } catch (_error) {
    // Keep the raw fragment when it is not valid percent-encoding.
  }
  const target = document.getElementById(id);
  if (!target || typeof target.scrollIntoView !== "function") return false;
  target.scrollIntoView({ block: "start" });
  return true;
};

const scrollToTop = () => {
  if (typeof window === "undefined" || typeof window.scrollTo !== "function") return;
  try {
    window.scrollTo(0, 0);
  } catch (_error) {
    // Some embedded browsers throw on programmatic scrolling; ignore.
  }
};

const PublicSiteShell = ({ children }) => {
  const { pathname, hash } = useLocation();
  const previousPathRef = useRef(pathname);

  useEffect(() => {
    const pathChanged = previousPathRef.current !== pathname;
    previousPathRef.current = pathname;

    if (hash) {
      // The target section renders in the same commit; wait one frame so the
      // browser has laid it out before jumping.
      const frame = window.requestAnimationFrame(() => {
        if (!scrollToHash(hash) && pathChanged) scrollToTop();
      });
      return () => window.cancelAnimationFrame(frame);
    }

    if (pathChanged) scrollToTop();
    return undefined;
  }, [pathname, hash]);

  return <div className="site">{children}</div>;
};

export default PublicSiteShell;
